export const isJSON = (data) => {
  let value = typeof data !== 'string' ? JSON.stringify(data) : data;
  try {
    value = JSON.parse(value);
  } catch (e) {
    return false;
  }
  return typeof value === 'object' && value !== null;
};

export const getUnformattedDate = (date) => {
  const unformattedDate = typeof date === 'string' ? date.replace(/-/g, '/')?.replace(/T.+/, '') : date;
  return new Date(unformattedDate);
};

export const formatDate = (d) => {
  const date = getUnformattedDate(d);
  let day = date.getDate();
  day = day < 10 ? `0${day}` : day;
  let month = date.toLocaleString('default', { month: 'numeric' });
  month = month < 10 ? `0${month}` : month;
  const year = date.toLocaleString('default', { year: 'numeric' });
  return `${month}/${day}/${year}`;
};

export default {
  isJSON,
  getUnformattedDate,
  formatDate,
};
